var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 116,
    viewBox: "0 0 95 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9448 116H46.472C41.2672 116.009 36.1117 114.991 31.3006 113.005C26.4894 111.02 22.117 108.105 18.4336 104.427C14.7501 100.75 11.8279 96.3826 9.83404 91.5748C7.84022 86.767 6.81396 81.6133 6.81396 76.4084V69.5991H94.4255L94.5585 76.4084C94.5585 81.6095 93.5338 86.7597 91.5427 91.5646C89.5517 96.3695 86.6334 100.735 82.9546 104.412C79.2758 108.088 74.9087 111.004 70.1027 112.993C65.2966 114.981 60.1459 116.003 54.9448 116Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9762 76.497C-1.54741 30.939 -1.65831 4.32286 4.59649 1.77214C22.1853 -5.50294 30.9908 40.2325 38.4434 71.6174C39.7298 57.8213 46.2951 38.5024 53.9695 40.2325C65.8358 42.9163 59.6476 69.2663 59.7585 74.3899C72.8669 43.5817 79.7206 42.6501 83.5799 44.5354C90.234 47.7737 81.7168 69.3106 75.9721 78.4932",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.3168a3ab4d1de0d22ad716f4438e80ea.svg";
export { ForwardRef as ReactComponent };